import { app } from "../firebase-config.js";
import { getFunctions, httpsCallable } from "firebase/functions";
import { UserService } from "./user.service.js";

// [CONFIGURATION] Toss Payments Keys
// NO HARDCODED LIVE KEYS HERE. 
// Keys must be injected via 'init' or 'request' methods from the caller (Control Layer).
const DEFAULT_TEST_KEY = "test_ck_ORzdMaqN3wP69dp6QpagV5AkYXQG";


export const VerificationService = {
    tossPayments: null,

    /**
     * Initialize Toss Payments SDK
     */
    init: async () => {
        // [FIX] Force Re-init to ensure correct SDK version matches
        if (!window.TossPayments) {
            throw new Error("Toss Payments SDK not loaded.");
        }

        // [FIX] Use DEFAULT_TEST_KEY constant (init is rarely called; requestAdultVerification handles its own init)
        VerificationService.tossPayments = window.TossPayments(DEFAULT_TEST_KEY);
        return VerificationService.tossPayments;
    },

    /**
     * Request Adult Verification (Identity Certification)
     * @param {string} returnUrl - URL to return to after success (usually current page)
     * @param {object} settings - Global Economy Settings [pg_mode, pg_client_key]
     */
    requestAdultVerification: async (returnUrl, settings = {}) => {
        try {
            console.log("🚀 [인증] 토스 성인인증 요청 시작 (Phone/PASS via Payment Auth)");

            // [Dynamic Config]
            const mode = settings.pg_mode || 'TEST';
            let clientKey = settings.pg_client_key;

            if (!clientKey) {
                if (mode === 'TEST') clientKey = DEFAULT_TEST_KEY;
                else throw new Error("Live Verification requires a configured Client Key.");
            }

            console.log(`[Verification] Initializing SDK in ${mode} mode.`);

            // Prepare Unique Order ID for Auth
            const orderId = `verify_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

            // 1. Initialize Toss Payment SDK
            if (!window.TossPayments) {
                throw new Error("Toss SDK not loaded. Please refresh.");
            }

            // Use the injected CLIENT_KEY
            const toss = window.TossPayments(clientKey);

            // 2. Prepare Return URLs
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('verification_status', 'success');

            // failUrl is now just window.location.href to avoid hash routing issues

            console.log("🚀 인증 창 호출 (Mobile Phone Auth - 100 KRW)");

            // 3. Call requestPayment -> Mobile Phone
            // [CRITICAL FIX] Toss API rejects amount: 0.
            await toss.requestPayment('휴대폰', {
                amount: 100,
                orderId: orderId,
                orderName: '본인인증 (100원-자동환불)',
                customerName: window.user?.displayName || 'Guest',
                successUrl: currentUrl.toString(),
                failUrl: window.location.href // [FIX] Stay on current page (hash compatible)
            });

            return true;

        } catch (error) {
            console.error("❌ 인증 요청 실패:", error);
            window.Modal.alert(`인증 초기화 오류: ${error.message}`);
            throw error;
        }
    },

    /**
     * Handle Verification Success (Called on Page Load if params exist)
     * @param {string} authKey - From URL Query
     */
    completeVerification: async (authKey) => {
        try {
            // [SERVER] Call Cloud Function to validate & update User DB
            const functions = getFunctions(app, 'us-central1');
            const verifyIdentityFn = httpsCallable(functions, 'verifyIdentity');

            const result = await verifyIdentityFn({ authKey });

            if (result.data.success) {
                // Refresh User Profile locally to reflect 'isAdultVerified'
                // Assuming global 'window.user' needs update or reload
                // Best to reload or re-fetch user profile
                return true;
            } else {
                throw new Error(result.data.message || "Verification failed on server.");
            }

        } catch (error) {
            console.error("Verification Completion Error", error);
            throw error;
        }
    }
};
